import { api } from 'data/api/api'

import {
  GetAvailablePickupPointsArgs,
  GetAvailablePickupPointsResp,
} from '../types/available-pickup-point'

export const getAvailablePickupPoints = ({
  shippingOrderId,
  countryCode,
  latitude,
  longitude,
  shipmentId,
  rateRootUuid,
}: GetAvailablePickupPointsArgs) =>
  api.get<GetAvailablePickupPointsResp>(
    `shipping_orders/${shippingOrderId}/nearby_pickup_points?country_code=${countryCode}&latitude=${latitude}&longitude=${longitude}&shipment_id=${shipmentId}&rate_root_uuid=${rateRootUuid}`,
  )
